// CircularLoadingIndicator.tsx

import React from "react";

type ThicknessType = number | string;

interface CircularLoaderProps {
    color?: string;
    thickness?: ThicknessType;
    className?: string;
}

export const CircularLoader: React.FC<CircularLoaderProps> = ({
    color = "#1976d2",
    thickness = 3.6,
    className,
}) => {
    const containerStyle = {
        width: "100%",
        height: "100%",
        display: "inline-block",
        position: "relative" as const,
        overflow: "visible",
    };

    const svgStyle = {
        color: color,
        display: "block",
        // width: "100%", // ----- TODO: WON'T BREAK ANYTHING?
        height: "100%",
        animation: "circular-rotate 1.4s linear infinite",
    };

    const circleStyle = {
        stroke: "currentColor",
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0,
        animation: "circular-dash 1.4s ease-in-out infinite",
        strokeLinecap: "round",
        fill: "none",
        overflow: "visible",
    };

    // Parse thickness to get numerical value for radius calculation
    const getThicknessValue = (thickness: ThicknessType): number => {
        if (typeof thickness === "number") {
            return thickness;
        }

        // Extract the numeric part if it's a string with units
        const match = thickness.match(/^(\d*\.?\d+)/);
        return match?.[1] ? parseFloat(match[1]) : 3.6; // Default to 3.6 if parsing fails
    };

    const thicknessValue = getThicknessValue(thickness);

    return (
        <span style={containerStyle} className={className}>
            <style>
                {`
          @keyframes circular-rotate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          
          @keyframes circular-dash {
            0% {
              stroke-dasharray: 1px, 200px;
              stroke-dashoffset: 0;
            }
            50% {
              stroke-dasharray: 100px, 200px;
              stroke-dashoffset: -15px;
            }
            100% {
              stroke-dasharray: 1px, 200px;
              stroke-dashoffset: -125px;
            }
          }
        `}
            </style>
            <svg style={svgStyle} viewBox="22 22 44 44">
                <circle
                    style={circleStyle as React.CSSProperties}
                    cx="44"
                    cy="44"
                    r={(44 - thicknessValue) / 2}
                    strokeWidth={thickness}
                />
            </svg>
        </span>
    );
};

export default CircularLoader;
